import {
  STREAMLAIN_MOTION,
  streamLainMotionTiming,
  streamLainOverlayKeyframes,
} from './streamlain-animation-controller';

export const STREAMLAIN_DISCLOSURE_INITIAL_SCALE = String(
  STREAMLAIN_MOTION.overlay.scale
);
export const STREAMLAIN_DISCLOSURE_ENTER_OFFSET = `${STREAMLAIN_MOTION.overlay.offset}px`;
export const STREAMLAIN_DISCLOSURE_ENTER_TIMING =
  streamLainMotionTiming('enter');
export const STREAMLAIN_DISCLOSURE_EXIT_TIMING = streamLainMotionTiming('exit');
export const STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_KEYFRAME =
  'streamlain-disclosure-overlay-enter';
export const STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_RIGHT_KEYFRAME =
  'streamlain-disclosure-overlay-enter-right';
export const STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_LEFT_KEYFRAME =
  'streamlain-disclosure-overlay-enter-left';
export const STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_ANIMATION = `${STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_KEYFRAME} ${STREAMLAIN_DISCLOSURE_ENTER_TIMING}`;
export const STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_RIGHT_ANIMATION = `${STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_RIGHT_KEYFRAME} ${STREAMLAIN_DISCLOSURE_ENTER_TIMING}`;
export const STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_LEFT_ANIMATION = `${STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_LEFT_KEYFRAME} ${STREAMLAIN_DISCLOSURE_ENTER_TIMING}`;

type StreamLainDisclosureKeyframes = ReturnType<
  typeof streamLainOverlayKeyframes
>;
export const streamLainDisclosureOverlayEnterKeyframes =
  streamLainOverlayKeyframes('bottom', 'enter');
export const streamLainDisclosureOverlayExitKeyframes =
  streamLainOverlayKeyframes('bottom', 'exit');
export const streamLainDisclosureOverlayEnterRightKeyframes =
  streamLainOverlayKeyframes('right', 'enter');
export const streamLainDisclosureOverlayExitRightKeyframes =
  streamLainOverlayKeyframes('right', 'exit');
export const streamLainDisclosureOverlayEnterLeftKeyframes =
  streamLainOverlayKeyframes('left', 'enter');
export const streamLainDisclosureOverlayExitLeftKeyframes =
  streamLainOverlayKeyframes('left', 'exit');

function keyframesCss(name: string, keyframes: StreamLainDisclosureKeyframes) {
  return `
    @keyframes ${name} {
      from {
        opacity: ${keyframes.from.opacity};
        transform: ${keyframes.from.transform};
      }
      to {
        opacity: ${keyframes.to.opacity};
        transform: ${keyframes.to.transform};
      }
    }
  `;
}

export function streamLainDisclosureOverlayKeyframesCss(
  names: {
    enter?: string;
    enterLeft?: string;
    enterRight?: string;
    exit?: string;
    exitLeft?: string;
    exitRight?: string;
  } = {}
) {
  const {
    enter = STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_KEYFRAME,
    enterLeft = STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_LEFT_KEYFRAME,
    enterRight = STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_RIGHT_KEYFRAME,
    exit,
    exitLeft,
    exitRight,
  } = names;

  return [
    keyframesCss(enter, streamLainDisclosureOverlayEnterKeyframes),
    keyframesCss(enterRight, streamLainDisclosureOverlayEnterRightKeyframes),
    keyframesCss(enterLeft, streamLainDisclosureOverlayEnterLeftKeyframes),
    exit
      ? keyframesCss(exit, streamLainDisclosureOverlayExitKeyframes)
      : undefined,
    exitRight
      ? keyframesCss(exitRight, streamLainDisclosureOverlayExitRightKeyframes)
      : undefined,
    exitLeft
      ? keyframesCss(exitLeft, streamLainDisclosureOverlayExitLeftKeyframes)
      : undefined,
  ]
    .filter(Boolean)
    .join('\n');
}
